import { Toaster } from "./components/ui/toaster.tsx";
import { Toaster as Sonner } from "./components/ui/sonner.tsx";
import { TooltipProvider } from "./components/ui/tooltip.tsx";
//import { QueryClient, QueryClientProvider } from ".tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

//const queryClient = new QueryClient();

const App = () => {  

return (   <TooltipProvider>
      <Toaster />
      <Sonner />
      <Index/>
    </TooltipProvider>
)
}

export default App;